"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.default = () => {
    if (typeof matchMedia !== 'function') {
        return 'light';
    }
    const media = matchMedia('(prefers-color-scheme: dark)');
    const [scheme, setScheme] = (0, react_1.useState)(media.matches ? 'dark' : 'light');
    (0, react_1.useEffect)(() => {
        /**
         * @param {MediaQueryListEvent} event
         */
        const handleMediaChange = (event) => setScheme(event.matches ? 'dark' : 'light');
        if (media.addEventListener) {
            media.addEventListener('change', handleMediaChange);
        }
        else {
            // polyfil for Safari and IE
            media.addListener((mql) => {
                if (mql.matches) {
                    handleMediaChange(mql);
                }
            });
        }
        return () => media.removeEventListener
            ? media.removeEventListener('change', handleMediaChange)
            : media.removeListener(handleMediaChange);
    });
    return scheme;
};
//# sourceMappingURL=index.js.map